// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimerContainer {
  background-color: #172639;
  color: white;
  height: auto;
  padding-bottom: 55px;
}

.disclaimerContainer .sectionHeading {
  font-weight: 900;
  color: white;
  letter-spacing: 1px;
}

.disclaimerContainer .sectionHeading:hover {
  font-weight: 900;
  color: #eaa627;
  letter-spacing: 1.5px;
}

.disclaimerContainer .disclaimerText {
  text-align: justify;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
}

@media (max-width: 1200px) {
  .disclaimerContainer .sectionHeading {
    font-size: 1.8rem;
  }
}

@media (max-width: 992px) {
  .disclaimerContainer .sectionHeading {
    font-size: 1.6rem;
  }
}

@media (max-width: 768px) {
  .disclaimerContainer .sectionHeading {
    font-size: 1.4rem;
  }
}

@media (max-width: 576px) {
  .disclaimerContainer .sectionHeading {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Disclaimer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".disclaimerContainer {\n  background-color: #172639;\n  color: white;\n  height: auto;\n  padding-bottom: 55px;\n}\n\n.disclaimerContainer .sectionHeading {\n  font-weight: 900;\n  color: white;\n  letter-spacing: 1px;\n}\n\n.disclaimerContainer .sectionHeading:hover {\n  font-weight: 900;\n  color: #eaa627;\n  letter-spacing: 1.5px;\n}\n\n.disclaimerContainer .disclaimerText {\n  text-align: justify;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n@media (max-width: 1200px) {\n  .disclaimerContainer .sectionHeading {\n    font-size: 1.8rem;\n  }\n}\n\n@media (max-width: 992px) {\n  .disclaimerContainer .sectionHeading {\n    font-size: 1.6rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .disclaimerContainer .sectionHeading {\n    font-size: 1.4rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .disclaimerContainer .sectionHeading {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
